import { Outlet, useParams } from "react-router-dom";

import { useAuth } from "@/modules/auth";

import { TabsWithRoute } from "@/components/TabsWithRoute";
import { ScrollableTabs } from "@/components/ScrollableTabs";
import { TabsContainer } from "../TabsContainer";

export function OperatingRoom() {
	const { attendanceId } = useParams();
	const { currentAuth } = useAuth();

	return (
		<>
			<TabsContainer>
				<ScrollableTabs>
					{currentAuth?.user.can("View-Surgical-Nursing-Act") && (
						<TabsWithRoute
							name="Ato Cirúrgico de Enfermagem"
							route={`/atendimento/${attendanceId}/sala-de-operacao/ato-cirurgico-de-enfermagem`}
						/>
					)}

					{currentAuth?.user.can("View-Surgical-Medical-Act") && (
						<TabsWithRoute
							name="Ato Cirúrgico Médico"
							route={`/atendimento/${attendanceId}/sala-de-operacao/ato-cirurgico-medico`}
						/>
					)}

					{currentAuth?.user.can("View-Surgical-Anesthetic-Act") && (
						<TabsWithRoute
							name="Ato Cirúrgico Anestésico"
							route={`/atendimento/${attendanceId}/sala-de-operacao/ato-cirurgico-anestesico`}
						/>
					)}
				</ScrollableTabs>
			</TabsContainer>

			<div id="operating-room-content">
				<Outlet />
			</div>
		</>
	);
}
